import { FlightStatus } from '@fe/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { UDViewTagSelectionEnum } from '../../../udView/udview';
import FlightStatusBadge from '../../components/FlightStatusBadge';
import { dashboardFlightFilters } from '../../utils/dashboard';
import { DashboardFlightColumn, DashboardFlightRow, DashboardFlightsPanel } from './DashboardFlightsPanel';

const columns: DashboardFlightColumn[] = [
    { id: 'acid', field: 'normalizedAcid', title: 'Aircraft ID', tagSelector: UDViewTagSelectionEnum.Acid },
    { id: 'acType', field: 'aircraftType', title: 'AcType', tagSelector: UDViewTagSelectionEnum.AircraftType },
    { id: 'origin', field: 'origin', title: 'Origin', tagSelector: UDViewTagSelectionEnum.Origin },
    {
        id: 'lastDestination',
        field: 'oldDestination',
        title: 'Old Dest',
        tagSelector: UDViewTagSelectionEnum.LastDestination
    },
    { id: 'destination', field: 'destination', title: 'New dest', tagSelector: UDViewTagSelectionEnum.Destination },
    { id: 'etaFAA', field: 'arrivalTime', title: 'ETA', tagSelector: UDViewTagSelectionEnum.EtaFaa }
];

const customColumns = [
    {
        id: 'onGround',
        field: 'onGround',
        title: 'On Ground',
        hidden: true
    },
    {
        id: 'flightStatus',
        field: 'flightStatus',
        title: 'Status',
        renderCell: (value: unknown, row: DashboardFlightRow) => (
            <FlightStatusBadge flightStatus={value as FlightStatus} ground={row.onGround as boolean} />
        )
    }
];

const defaultSort: SortDescriptor[] = [{ field: 'normalizedAcid', dir: 'asc' }];

export function DivertingFlightsList() {
    return (
        <DashboardFlightsPanel
            title="Diverting flights"
            flightFilters={dashboardFlightFilters.diverting}
            columns={columns}
            defaultSort={defaultSort}
            customColumns={customColumns}
            variant="diverting"
            emptyText="No diverting flights"
        />
    );
}
